import { render } from "./Diferido.vue?vue&type=template&id=b264d354&scoped=true"
import script from "./Diferido.vue?vue&type=script&lang=js"
export * from "./Diferido.vue?vue&type=script&lang=js"

import "./Diferido.vue?vue&type=style&index=0&id=b264d354&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b264d354"]])

export default __exports__